
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/guides/toplists/[id]",
      function () {
        return require("private-next-pages/guides/toplists/[id].jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/guides/toplists/[id]"])
      });
    }
  